import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Firebase Auth action-code dispatcher.
 *
 * Firebase sends all auth-action emails (reset password, verify email, etc.)
 * to a single "Action URL" configured in the Firebase Console template
 * settings. This page reads the `mode` query parameter that Firebase appends
 * and redirects to the matching custom page, preserving all query params
 * (oobCode, continueUrl, etc.).
 */
export function AuthActionPage() {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const params = searchParams.toString();

  switch (mode) {
    case 'resetPassword':
      return <Navigate to={`/reset-password?${params}`} replace />;
    case 'verifyEmail':
      return <Navigate to={`/verify-email?${params}`} replace />;
    default:
      return <Navigate to="/" replace />;
  }
}
